// import React, { useState } from 'react';
// import { Link, useSearchParams } from 'react-router-dom';
// import { QRCodeSVG } from 'qrcode.react';

// const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';
// const UPI_ID = 'sharmasunidhi7876@oksbi';
// const UPI_NAME = 'Docmize';
// const AMOUNT = '1'; // Change to 1000 for production

// const BookAppointment = () => {
//   const [searchParams] = useSearchParams();
//   const doctorName = searchParams.get('doctor') || '';
//   const clinicName = searchParams.get('clinic') || '';
//   const selectedSlot = searchParams.get('slot') || '';
//   const doctorPhone = searchParams.get('phone') || '';

//   const isFromProfile = !!(doctorName && selectedSlot);

//   const [showPayment, setShowPayment] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [submittedUpiRef, setSubmittedUpiRef] = useState('');

//   const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
//   const [errors, setErrors] = useState({});
//   const [upiRef, setUpiRef] = useState('');
//   const [upiError, setUpiError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [apiError, setApiError] = useState('');

//   const upiLink = `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(UPI_NAME)}&am=${AMOUNT}&cu=INR`;

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: '' });
//   };

//   const validate = () => {
//     const e = {};
//     if (!form.name.trim()) e.name = 'Please enter your name';
//     if (!form.phone.trim()) e.phone = 'Please enter your phone number';
//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const handleProceed = (e) => {
//     e.preventDefault();
//     if (validate()) setShowPayment(true);
//   };

//   const handleConfirm = async () => {
//     if (!upiRef.trim()) { setUpiError('Please enter UPI Reference Number'); return; }
//     setUpiError('');
//     setLoading(true);
//     setApiError('');
//     try {
//       const res = await fetch(`${API}/api/bookings`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           doctorName, clinicName, slot: selectedSlot, doctorPhone,
//           patientName: form.name, patientPhone: form.phone,
//           patientEmail: form.email, message: form.message,
//           transactionId: upiRef.trim(),
//           amount: `₹${AMOUNT}`,
//           source: isFromProfile ? 'profile' : 'navbar',
//         }),
//       });
//       const data = await res.json();
//       if (data.success) {
//         setSubmittedUpiRef(upiRef.trim());
//         setSubmitted(true);
//       } else {
//         setApiError(data.message || 'Something went wrong. Please try again.');
//       }
//     } catch (err) {
//       setApiError('Unable to connect. Please try again.');
//     }
//     setLoading(false);
//   };

//   const inp = (hasError) => ({
//     width: '100%', padding: '12px 16px', fontSize: 14, color: '#333',
//     border: `1.5px solid ${hasError ? '#e53935' : '#e2e8f0'}`,
//     borderRadius: 8, outline: 'none', background: '#fff',
//     boxSizing: 'border-box', fontFamily: 'inherit',
//     transition: 'border-color 0.2s',
//   });

//   // ── Success ────────────────────────────────────────────────────────────────
//   if (submitted) return (
//     <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', fontFamily: "'Segoe UI', sans-serif", padding: '40px 24px' }}>
//       <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 8px 40px rgba(0,0,0,0.10)', padding: '48px 36px', maxWidth: 460, width: '100%', textAlign: 'center' }}>
//         <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
//           <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
//         </div>
//         <h2 style={{ fontSize: 24, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>Request Submitted!</h2>
//         <p style={{ fontSize: 14, color: '#64748b', marginBottom: 6 }}>Your appointment request has been received.</p>
//         <p style={{ fontSize: 14, color: '#64748b', marginBottom: 24 }}>Our team will verify your payment and <strong>contact you shortly</strong> to confirm.</p>
//         {isFromProfile && (
//           <div style={{ background: '#f0f7fb', border: '1px solid #d0e8f5', borderRadius: 10, padding: '14px 18px', marginBottom: 16, textAlign: 'left' }}>
//             <div style={{ fontSize: 13, fontWeight: 700, color: '#19354a' }}>{doctorName}</div>
//             <div style={{ fontSize: 13, color: '#555' }}>{clinicName}</div>
//             <div style={{ fontSize: 13, color: '#39a5d3', fontWeight: 600, marginTop: 4 }}>Slot: {selectedSlot}</div>
//           </div>
//         )}
//         <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 18px', marginBottom: 24, textAlign: 'left' }}>
//           <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 4, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>UPI Reference Number</div>
//           <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', letterSpacing: '0.08em' }}>{submittedUpiRef}</div>
//           <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>Please keep this reference number safe.</div>
//         </div>
//         <Link to="/doctors" style={{ display: 'block', background: '#19354a', color: '#fff', padding: '13px 0', borderRadius: 8, fontSize: 14, fontWeight: 700, textDecoration: 'none' }}>
//           Browse Doctors
//         </Link>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'Segoe UI', sans-serif" }}>

//       {/* Header */}
//       <div style={{ background: '#19354a', padding: '28px 24px', textAlign: 'center' }}>
//         <h1 style={{ fontSize: 24, fontWeight: 700, color: '#fff', margin: '0 0 6px' }}>Book an Appointment</h1>
//         <p style={{ fontSize: 14, color: '#a8c0cc', margin: 0 }}>
//           {isFromProfile ? `Booking with ${doctorName}` : 'Fill in your details and we will call you to confirm'}
//         </p>
//       </div>

//       <div style={{ maxWidth: 760, margin: '40px auto', padding: '0 24px' }}>

//         {/* ── STEP 1: Patient Form ─────────────────────────────────────────────── */}
//         {!showPayment && (
//           <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', borderTop: '4px solid #19354a', overflow: 'hidden' }}>
//             <div style={{ padding: '24px 32px', borderBottom: '1px solid #f1f5f9' }}>
//               <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>Patient Information</h2>
//             </div>

//             {isFromProfile && (
//               <div style={{ margin: '20px 32px 0', background: '#f0f7fb', borderLeft: '4px solid #19354a', borderRadius: 6, padding: '12px 16px' }}>
//                 <p style={{ fontSize: 14, color: '#19354a', fontWeight: 600, margin: 0 }}>
//                   Booking with <strong>{doctorName}</strong> — {clinicName}
//                 </p>
//                 <p style={{ fontSize: 13, color: '#39a5d3', margin: '4px 0 0', fontWeight: 600 }}>Slot: {selectedSlot}</p>
//               </div>
//             )}

//             <form onSubmit={handleProceed} style={{ padding: '24px 32px 32px', display: 'flex', flexDirection: 'column', gap: 20 }}>

//               <div>
//                 <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Full Name *</label>
//                 <input name="name" value={form.name} onChange={handleChange} placeholder="Enter your full name" style={inp(errors.name)} />
//                 {errors.name && <div style={{ fontSize: 12, color: '#e53935', marginTop: 4 }}>{errors.name}</div>}
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Mobile Number *</label>
//                   <input name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" style={inp(errors.phone)} />
//                   {errors.phone && <div style={{ fontSize: 12, color: '#e53935', marginTop: 4 }}>{errors.phone}</div>}
//                 </div>
//                 <div>
//                   <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Email Address <span style={{ color: '#94a3b8', fontWeight: 400 }}>(optional)</span></label>
//                   <input name="email" value={form.email} onChange={handleChange} placeholder="your@email.com" style={inp(false)} />
//                 </div>
//               </div>

//               <div>
//                 <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Additional Message <span style={{ color: '#94a3b8', fontWeight: 400 }}>(optional)</span></label>
//                 <textarea name="message" value={form.message} onChange={handleChange} placeholder="Any specific concerns or symptoms..." rows={3}
//                   style={{ ...inp(false), resize: 'vertical', lineHeight: 1.6 }} />
//               </div>

//               {/* Fee Summary */}
//               <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div>
//                   <div style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>Consultation Fee</div>
//                   <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 2 }}>Pay via UPI QR on next step</div>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                   <div style={{ fontSize: 30, fontWeight: 800, color: '#19354a' }}>₹{AMOUNT}</div>
//                   <div style={{ fontSize: 12, color: '#94a3b8' }}>UPI Payment</div>
//                 </div>
//               </div>

//               <button type="submit" style={{ width: '100%', padding: '14px 0', background: '#19354a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
//                 Proceed to Payment →
//               </button>
//             </form>
//           </div>
//         )}

//         {/* ── STEP 2: Payment ──────────────────────────────────────────────────── */}
//         {showPayment && (
//           <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', borderTop: '4px solid #19354a', overflow: 'hidden' }}>
//             <div style={{ padding: '20px 32px', borderBottom: '1px solid #f1f5f9', background: '#f8fafc' }}>
//               <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', margin: '0 0 4px' }}>Complete Payment</h2>
//               <p style={{ fontSize: 13, color: '#64748b', margin: 0 }}>Scan QR code and enter UPI reference number</p>
//             </div>

//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: 420 }}>

//               {/* Left — QR */}
//               <div style={{ padding: '36px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderRight: '1px solid #f1f5f9' }}>
//                 <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 20 }}>Scan to Pay</div>
//                 <div style={{ padding: 16, borderRadius: 16, border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', background: '#fff' }}>
//                   <QRCodeSVG value={upiLink} size={176} level="H" />
//                 </div>
//                 <div style={{ marginTop: 20, textAlign: 'center' }}>
//                   <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>DOCMIZE</div>
//                   <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>All UPI Apps Accepted</div>
//                   <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginTop: 10, flexWrap: 'wrap' }}>
//                     {['GPay', 'PhonePe', 'Paytm', 'BHIM'].map(app => (
//                       <span key={app} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, background: '#f1f5f9', color: '#64748b', fontWeight: 600 }}>{app}</span>
//                     ))}
//                   </div>
//                 </div>
//                 <div style={{ marginTop: 20, background: '#f0f7fb', borderRadius: 10, padding: '12px 24px', textAlign: 'center' }}>
//                   <div style={{ fontSize: 11, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Amount to Pay</div>
//                   <div style={{ fontSize: 34, fontWeight: 900, color: '#19354a', marginTop: 4 }}>₹{AMOUNT}</div>
//                 </div>
//                 <a href={upiLink} style={{ marginTop: 14, display: 'block', textAlign: 'center', background: '#f1f5f9', color: '#374151', padding: '10px 24px', borderRadius: 8, fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>
//                   Open UPI App
//                 </a>
//               </div>

//               {/* Right — Summary + UPI Ref */}
//               <div style={{ padding: '36px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 20 }}>

//                 {/* Appointment Summary */}
//                 <div style={{ background: '#f8fafc', borderRadius: 10, padding: '16px 18px', border: '1px solid #e2e8f0' }}>
//                   <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 12 }}>Appointment Summary</div>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                     {[
//                       { label: 'Patient', value: form.name },
//                       { label: 'Phone', value: form.phone },
//                       doctorName && { label: 'Doctor', value: doctorName },
//                       clinicName && { label: 'Clinic', value: clinicName },
//                       selectedSlot && { label: 'Slot', value: selectedSlot },
//                     ].filter(Boolean).map(item => (
//                       <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
//                         <span style={{ color: '#64748b' }}>{item.label}</span>
//                         <span style={{ fontWeight: 600, color: '#1a1a2e', maxWidth: 160, textAlign: 'right' }}>{item.value}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* UPI Reference */}
//                 <div>
//                   <label style={{ display: 'block', fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 6 }}>UPI Reference Number *</label>
//                   <p style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10, marginTop: 0 }}>After payment, find the 12-digit UTR/Reference number in your UPI app transaction history</p>
//                   <input
//                     value={upiRef}
//                     onChange={e => { setUpiRef(e.target.value); setUpiError(''); }}
//                     placeholder="e.g. 426789123456"
//                     maxLength={20}
//                     style={{ ...inp(upiError), fontSize: 16, fontWeight: 700, letterSpacing: '0.08em', borderColor: upiRef ? '#19354a' : upiError ? '#e53935' : '#e2e8f0' }}
//                   />
//                   {upiError && <div style={{ fontSize: 12, color: '#e53935', marginTop: 4 }}>{upiError}</div>}
//                 </div>

//                 {apiError && (
//                   <div style={{ background: '#fdecea', border: '1px solid #f5c6cb', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#c62828' }}>
//                     {apiError}
//                   </div>
//                 )}

//                 <button onClick={handleConfirm} disabled={loading || !upiRef.trim()}
//                   style={{ width: '100%', padding: '14px 0', background: upiRef.trim() ? '#16a34a' : '#94a3b8', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: upiRef.trim() ? 'pointer' : 'not-allowed', fontFamily: 'inherit', transition: 'background 0.2s' }}>
//                   {loading ? 'Submitting...' : '✓ Confirm Appointment'}
//                 </button>

//                 <button onClick={() => setShowPayment(false)}
//                   style={{ width: '100%', padding: '12px 0', background: '#fff', color: '#64748b', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
//                   ← Edit Details
//                 </button>

//                 <p style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', margin: 0 }}>
//                   Your appointment will be confirmed after payment verification by our team
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Important Info */}
//         <div style={{ marginTop: 24, background: '#f0f7fb', borderLeft: '4px solid #19354a', borderRadius: 8, padding: '20px 24px' }}>
//           <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', margin: '0 0 12px' }}>Important Information</h3>
//           <ul style={{ margin: 0, paddingLeft: 20, color: '#64748b', fontSize: 13, lineHeight: 2 }}>
//             <li>Please arrive 15 minutes before your scheduled appointment</li>
//             <li>Bring all relevant medical records and reports</li>
//             <li>You will receive confirmation after payment verification</li>
//             <li>For cancellation, contact us at least 24 hours in advance</li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookAppointment;


// import React, { useState } from 'react';
// import { useSearchParams } from 'react-router-dom';

// const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

// export default function BookAppointment() {
//   const [searchParams] = useSearchParams();

//   // Pre-fill from doctor profile if coming via slot picker
//   const doctorName  = searchParams.get('doctor')  || '';
//   const clinicName  = searchParams.get('clinic')  || '';
//   const slot        = searchParams.get('slot')    || '';
//   const doctorPhone = searchParams.get('phone')   || '';

//   const [form, setForm] = useState({
//     patientName: '',
//     patientPhone: '',
//     patientEmail: '',
//     message: '',
//   });

//   const [status, setStatus] = useState('idle'); // idle | loading | success | error
//   const [errorMsg, setErrorMsg] = useState('');

//   const handleChange = (e) => {
//     setForm(f => ({ ...f, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async () => {
//     if (!form.patientName.trim()) { setErrorMsg('Please enter your name.'); return; }
//     if (!form.patientPhone.trim()) { setErrorMsg('Please enter your phone number.'); return; }
//     setErrorMsg('');
//     setStatus('loading');

//     try {
//       const res = await fetch(`${API_URL}/api/bookings`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           doctorName, clinicName, slot, doctorPhone,
//           patientName:  form.patientName.trim(),
//           patientPhone: form.patientPhone.trim(),
//           patientEmail: form.patientEmail.trim(),
//           message:      form.message.trim(),
//           source: doctorName ? 'profile' : 'navbar',
//         }),
//       });

//       const data = await res.json();
//       if (data.success) {
//         setStatus('success');
//       } else {
//         setErrorMsg(data.message || 'Something went wrong.');
//         setStatus('error');
//       }
//     } catch (err) {
//       setErrorMsg('Unable to connect. Please try again.');
//       setStatus('error');
//     }
//   };

//   // ── Success Screen ──────────────────────────────────────────────────────────
//   if (status === 'success') {
//     return (
//       <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif", padding: 24 }}>
//         <div style={{ background: '#fff', borderRadius: 8, padding: '48px 40px', maxWidth: 480, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}>
//           <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
//             <svg width="32" height="32" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
//           </div>
//           <h2 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', marginBottom: 10 }}>Request Submitted!</h2>
//           <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7, marginBottom: 6 }}>
//             Thank you, <strong>{form.patientName}</strong>. We have received your appointment request.
//           </p>
//           <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7, marginBottom: 28 }}>
//             Our team will contact you on <strong>{form.patientPhone}</strong> within 24 hours to confirm your booking.
//             {form.patientEmail && <> A confirmation has also been sent to <strong>{form.patientEmail}</strong>.</>}
//           </p>
//           {doctorName && (
//             <div style={{ background: '#f0f7fb', borderRadius: 6, padding: '12px 16px', marginBottom: 24, textAlign: 'left', fontSize: 13, color: '#444', lineHeight: 1.8 }}>
//               <div><span style={{ color: '#888' }}>Doctor: </span><strong>{doctorName}</strong></div>
//               {clinicName && <div><span style={{ color: '#888' }}>Clinic: </span>{clinicName}</div>}
//               {slot && <div><span style={{ color: '#888' }}>Requested Slot: </span><strong>{slot}</strong></div>}
//             </div>
//           )}
//           <a href="/" style={{ display: 'inline-block', background: '#39a5d3', color: '#fff', borderRadius: 6, padding: '10px 28px', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>Back to Home</a>
//         </div>
//       </div>
//     );
//   }

//   // ── Form ────────────────────────────────────────────────────────────────────
//   return (
//     <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif", padding: 24 }}>
//       <div style={{ background: '#fff', borderRadius: 8, padding: '40px', maxWidth: 520, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}>

//         {/* Header */}
//         <div style={{ marginBottom: 28 }}>
//           <h1 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', margin: '0 0 6px' }}>Book an Appointment</h1>
//           <p style={{ fontSize: 13, color: '#888', margin: 0 }}>Fill in your details and we'll get back to you within 24 hours.</p>
//         </div>

//         {/* Doctor info banner — shown if coming from a doctor profile */}
//         {doctorName && (
//           <div style={{ background: '#f0f7fb', border: '1px solid #d0e8f5', borderRadius: 6, padding: '12px 16px', marginBottom: 24, fontSize: 13, color: '#444', lineHeight: 1.8 }}>
//             <div><span style={{ color: '#888' }}>Doctor: </span><strong style={{ color: '#19354a' }}>{doctorName}</strong></div>
//             {clinicName && <div><span style={{ color: '#888' }}>Clinic: </span>{clinicName}</div>}
//             {slot && <div><span style={{ color: '#888' }}>Selected Slot: </span><strong style={{ color: '#39a5d3' }}>{slot}</strong></div>}
//           </div>
//         )}

//         {/* Fields */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

//           {/* Name */}
//           <div>
//             <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
//               Full Name <span style={{ color: '#e85a2c' }}>*</span>
//             </label>
//             <input
//               name="patientName"
//               value={form.patientName}
//               onChange={handleChange}
//               placeholder="Enter your full name"
//               style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333' }}
//             />
//           </div>

//           {/* Phone */}
//           <div>
//             <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
//               Phone Number <span style={{ color: '#e85a2c' }}>*</span>
//             </label>
//             <input
//               name="patientPhone"
//               value={form.patientPhone}
//               onChange={handleChange}
//               placeholder="Enter your phone number"
//               type="tel"
//               style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333' }}
//             />
//           </div>

//           {/* Email */}
//           <div>
//             <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
//               Email Address <span style={{ color: '#aaa', fontWeight: 400, textTransform: 'none', fontSize: 11 }}>(optional)</span>
//             </label>
//             <input
//               name="patientEmail"
//               value={form.patientEmail}
//               onChange={handleChange}
//               placeholder="Enter your email (for confirmation)"
//               type="email"
//               style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333' }}
//             />
//           </div>

//           {/* Message */}
//           <div>
//             <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
//               Message <span style={{ color: '#aaa', fontWeight: 400, textTransform: 'none', fontSize: 11 }}>(optional)</span>
//             </label>
//             <textarea
//               name="message"
//               value={form.message}
//               onChange={handleChange}
//               placeholder="Describe your concern or any specific requirement..."
//               rows={4}
//               style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333', lineHeight: 1.6 }}
//             />
//           </div>

//           {/* Error */}
//           {errorMsg && (
//             <div style={{ background: '#fff5f5', border: '1px solid #ffcccc', borderRadius: 6, padding: '10px 14px', fontSize: 13, color: '#c0392b' }}>
//               {errorMsg}
//             </div>
//           )}

//           {/* Submit */}
//           <button
//             onClick={handleSubmit}
//             disabled={status === 'loading'}
//             style={{ width: '100%', padding: '13px', fontSize: 14, fontWeight: 700, background: status === 'loading' ? '#a8d8ee' : '#39a5d3', color: '#fff', border: 'none', borderRadius: 6, cursor: status === 'loading' ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'background 0.2s', marginTop: 4 }}
//           >
//             {status === 'loading' ? 'Submitting...' : 'Submit Appointment Request'}
//           </button>

//           <p style={{ fontSize: 12, color: '#aaa', textAlign: 'center', margin: 0 }}>
//             No booking fee · Our team will confirm within 24 hours
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

// Get today's date in YYYY-MM-DD format for min attribute
const today = new Date().toISOString().split('T')[0];

export default function BookAppointment() {
  const [searchParams] = useSearchParams();

  const doctorName  = searchParams.get('doctor')  || '';
  const clinicName  = searchParams.get('clinic')  || '';
  const slot        = searchParams.get('slot')    || '';
  const doctorPhone = searchParams.get('phone')   || '';

  const [form, setForm] = useState({
    patientName: '',
    patientPhone: '',
    patientEmail: '',
    appointmentDate: '',
    message: '',
  });

  const [status, setStatus] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    if (!form.patientName.trim()) { setErrorMsg('Please enter your name.'); return; }
    if (!form.patientPhone.trim()) { setErrorMsg('Please enter your phone number.'); return; }
    if (!form.appointmentDate) { setErrorMsg('Please select a preferred date.'); return; }
    setErrorMsg('');
    setStatus('loading');

    try {
      const res = await fetch(`${API_URL}/api/bookings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          doctorName, clinicName, slot, doctorPhone,
          patientName:     form.patientName.trim(),
          patientPhone:    form.patientPhone.trim(),
          patientEmail:    form.patientEmail.trim(),
          appointmentDate: form.appointmentDate,
          message:         form.message.trim(),
          source: doctorName ? 'profile' : 'navbar',
        }),
      });

      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setErrorMsg(data.message || 'Something went wrong.');
        setStatus('error');
      }
    } catch (err) {
      setErrorMsg('Unable to connect. Please try again.');
      setStatus('error');
    }
  };

  // ── Success Screen ──────────────────────────────────────────────────────────
  if (status === 'success') {
    return (
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif", padding: 24 }}>
        <div style={{ background: '#fff', borderRadius: 8, padding: '48px 40px', maxWidth: 480, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', marginBottom: 10 }}>Request Submitted!</h2>
          <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7, marginBottom: 6 }}>
            Thank you, <strong>{form.patientName}</strong>. We have received your appointment request.
          </p>
          <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7, marginBottom: 28 }}>
            Our team will contact you on <strong>{form.patientPhone}</strong> within 24 hours to confirm your booking.
            {form.patientEmail && <> A confirmation has also been sent to <strong>{form.patientEmail}</strong>.</>}
          </p>
          {(doctorName || form.appointmentDate) && (
            <div style={{ background: '#f0f7fb', borderRadius: 6, padding: '12px 16px', marginBottom: 24, textAlign: 'left', fontSize: 13, color: '#444', lineHeight: 1.8 }}>
              {doctorName && <div><span style={{ color: '#888' }}>Doctor: </span><strong>{doctorName}</strong></div>}
              {clinicName && <div><span style={{ color: '#888' }}>Clinic: </span>{clinicName}</div>}
              {form.appointmentDate && <div><span style={{ color: '#888' }}>Preferred Date: </span><strong>{new Date(form.appointmentDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</strong></div>}
              {slot && <div><span style={{ color: '#888' }}>Requested Slot: </span><strong>{slot}</strong></div>}
            </div>
          )}
          <a href="/" style={{ display: 'inline-block', background: '#39a5d3', color: '#fff', borderRadius: 6, padding: '10px 28px', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>Back to Home</a>
        </div>
      </div>
    );
  }

  // ── Form ────────────────────────────────────────────────────────────────────
  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif", padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: '40px', maxWidth: 520, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}>

        {/* Header */}
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', margin: '0 0 6px' }}>Book an Appointment</h1>
          <p style={{ fontSize: 13, color: '#888', margin: 0 }}>Fill in your details and we'll get back to you within 24 hours.</p>
        </div>

        {/* Doctor info banner */}
        {doctorName && (
          <div style={{ background: '#f0f7fb', border: '1px solid #d0e8f5', borderRadius: 6, padding: '12px 16px', marginBottom: 24, fontSize: 13, color: '#444', lineHeight: 1.8 }}>
            <div><span style={{ color: '#888' }}>Doctor: </span><strong style={{ color: '#19354a' }}>{doctorName}</strong></div>
            {clinicName && <div><span style={{ color: '#888' }}>Clinic: </span>{clinicName}</div>}
            {slot && <div><span style={{ color: '#888' }}>Selected Slot: </span><strong style={{ color: '#39a5d3' }}>{slot}</strong></div>}
          </div>
        )}

        {/* Fields */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Name */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Full Name <span style={{ color: '#e85a2c' }}>*</span>
            </label>
            <input
              name="patientName"
              value={form.patientName}
              onChange={handleChange}
              placeholder="Enter your full name"
              style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333' }}
            />
          </div>

          {/* Phone */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Phone Number <span style={{ color: '#e85a2c' }}>*</span>
            </label>
            <input
              name="patientPhone"
              value={form.patientPhone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              type="tel"
              style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333' }}
            />
          </div>

          {/* Email */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Email Address <span style={{ color: '#aaa', fontWeight: 400, textTransform: 'none', fontSize: 11 }}>(optional)</span>
            </label>
            <input
              name="patientEmail"
              value={form.patientEmail}
              onChange={handleChange}
              placeholder="Enter your email (for confirmation)"
              type="email"
              style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333' }}
            />
          </div>

          {/* Preferred Date */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Preferred Date <span style={{ color: '#e85a2c' }}>*</span>
            </label>
            <input
              name="appointmentDate"
              value={form.appointmentDate}
              onChange={handleChange}
              type="date"
              min={today}
              style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: form.appointmentDate ? '#333' : '#aaa' }}
            />
          </div>

          {/* Message */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Message <span style={{ color: '#aaa', fontWeight: 400, textTransform: 'none', fontSize: 11 }}>(optional)</span>
            </label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Describe your concern or any specific requirement..."
              rows={4}
              style={{ width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', color: '#333', lineHeight: 1.6 }}
            />
          </div>

          {/* Error */}
          {errorMsg && (
            <div style={{ background: '#fff5f5', border: '1px solid #ffcccc', borderRadius: 6, padding: '10px 14px', fontSize: 13, color: '#c0392b' }}>
              {errorMsg}
            </div>
          )}

          {/* Submit */}
          <button
            onClick={handleSubmit}
            disabled={status === 'loading'}
            style={{ width: '100%', padding: '13px', fontSize: 14, fontWeight: 700, background: status === 'loading' ? '#a8d8ee' : '#39a5d3', color: '#fff', border: 'none', borderRadius: 6, cursor: status === 'loading' ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'background 0.2s', marginTop: 4 }}
          >
            {status === 'loading' ? 'Submitting...' : 'Submit Appointment Request'}
          </button>

          <p style={{ fontSize: 12, color: '#aaa', textAlign: 'center', margin: 0 }}>
            No booking fee · Our team will confirm within 24 hours
          </p>
        </div>
      </div>
    </div>
  );
}